import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslation from './locales/en.json';
import arTranslation from './locales/ar.json';

 /**
      * Used for import json for both the languages and render 
      */

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: enTranslation
    },
    ar: {
      translation: arTranslation
    }
  },
  lng: 'en', // Default language
  fallbackLng: 'en', // Fallback language if a translation is missing
  interpolation: {
    escapeValue: false
  }
});

export default i18n;
